import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { useLocation } from "react-router-dom";
import { domain, getItemMenu, getRespondeHistoriadora } from "../../assets/js/api";

export default function RespondeHistoriadora({ section_id }) {
    const location = useLocation();
    const [preguntes, setPreguntes] = useState(null);
    const [item, setItem] = useState(location.state?.item || null);

    useEffect(() => {
        if (section_id && !item) {
            getItemMenu(section_id).then((foundItem) => {
                setItem(foundItem);
            });
        }
    }, [section_id, item]);

    useEffect(() => {
        if (item) {
            getRespondeHistoriadora(item, null, true).then((data) => setPreguntes(data));
        }
    }, [item]);

    const createTitle = (title) => {
        const words = title.split(" ");

        if (words.length >= 2) {
            words[words.length - 1] = (
                <span className="has-text-primary">{words[words.length - 1]}</span>
            );
        }

        return (
            <>
                {words.map((word, index) => (
                    <React.Fragment key={index}>
                        {word}
                        {index < words.length - 1 && ' '}
                    </React.Fragment>
                ))}
            </>
        );
    };

    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header></Header>

                <main id="main" className="is-relative mb-7">
                    <div className="wrapper flow--l">
                        <h1 className="has-text-centered">{item ? createTitle(item.term) : ""}</h1>
                        <p className="has-text-centered">{item ? item.abstract : ""}</p>
                    </div>
                    <div className="wrapper mt-7 flow--xl">
                        {preguntes && preguntes.length > 0  ? (
                            preguntes.map((pregunta, index) => (
                                pregunta && pregunta.fragmentData  ? (
                                    <details key={pregunta.id || index}>
                                        <summary>
                                            <h2 className="has-text-weight-bold is-size-5">{pregunta.term}</h2>
                                        </summary>
                                        <div className="pt-2 flow is-size-6">
                                            <div className="columns is-centered">
                                                <div className="column is-9-desktop is-7-widescreen">
                                                    <div className="video-container">
                                                        <iframe
                                                            loading="lazy"
                                                            width="640"
                                                            height="360"
                                                            src={domain + pregunta.fragmentData.video_url}
                                                            allowFullScreen
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </details>
                                ) : null
                            ))
                        ) : null}
                    </div>
                </main>
                <Footer></Footer>
            </div>
        </Layout>
    );
}
